import React, { useEffect, useState } from 'react';
import './Cookies.css';

const cookieName = 'cookies-consent';

const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
};

const getCookie = (name) => {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(name + '='))
    ?.split('=')[1];
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [showRegret, setShowRegret] = useState(false);

  useEffect(() => {
    const consent = getCookie(cookieName);
    console.log('CookieBanner useEffect consent:', consent); // Debug log
    setVisible(true); // Force show banner for debugging
  }, []);

  const handleAccept = () => {
    setCookie(cookieName, 'accepted', 365);
    setVisible(false);
    setShowWelcome(true);
    // Hide welcome message after 5 seconds
    setTimeout(() => setShowWelcome(false), 5000);
  };

  const handleDecline = () => {
    setCookie(cookieName, 'declined', 365);
    setVisible(false);
    setShowRegret(true);
    // Hide regret message after 5 seconds
    setTimeout(() => setShowRegret(false), 5000);
  };

  if (!visible && !showWelcome && !showRegret) return null;

  return (
    <>
      {visible && (
        <div id="cookies" className="cookies">
          <p>
            🍪 We use cookies to improve your experience. Accept or decline?
            <br />
            See our <a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>.
          </p>
          <div className="cookie-buttons">
            <button id="cookie-accept" onClick={handleAccept}>Accept</button>
            <button id="cookie-decline" onClick={handleDecline}>Decline</button>
          </div>
        </div>
      )}
      {showWelcome && (
        <div id="welcome-message" className="welcome-message">
          <p>Welcome! 🎉 Thanks for accepting our cookies. Enjoy your experience! 🍪✨</p>
        </div>
      )}
      {showRegret && (
        <div id="regret-message" className="regret-message">
          <p> 👍 We respect your choice to decline cookies. While some features might be limited, we hope you still have a great experience. 😊</p>
        </div>
      )}
    </>
  );
};

export default CookieBanner;
